import * as React from "react";

import { isChildOfType, nullElement } from "../../TypingUtils";

import { Otherwise } from "./Otherwise";
import { When } from "./When";

export interface ChoiceProps {
    value: string;
    children: React.ReactNode;
}

export function Choice(props: ChoiceProps): JSX.Element | null {
    const children = React.Children.toArray(props.children);
    let otherwise: JSX.Element | undefined;
    for (const child of children) {
        if (isChildOfType(child, When) && child.props.test === props.value) {
            return child;
        }
        if (isChildOfType(child, Otherwise)) {
            otherwise = child;
        }
    }

    return otherwise ?? nullElement;
}
